var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74292 6.49995L12.785 3.66888C13.5408 2.96646 13.5836 1.78328 12.8811 1.02744C12.1787 0.271597 10.9955 0.228864 10.2397 0.93129L6.99998 3.94665L3.75761 0.93129C3.00177 0.228864 1.81859 0.271597 1.11617 1.02744C0.413739 1.78328 0.456473 2.96646 1.21232 3.66888L4.25705 6.49995L1.21232 9.33102C0.456473 10.0334 0.413739 11.2166 1.11617 11.9725C1.48474 12.3677 1.98418 12.5681 2.4863 12.5681C2.94301 12.5681 3.39972 12.4025 3.76028 12.0659L7.00266 9.05059L10.2424 12.0659C10.6029 12.3998 11.0596 12.5681 11.5163 12.5681C12.0185 12.5681 12.5179 12.3677 12.8865 11.9725C13.5889 11.2166 13.5462 10.0334 12.7903 9.33102L9.74292 6.49995Z",
    fill: "#B3B9BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.df33f928ebde94dcd49755681016747e.svg";
export { ForwardRef as ReactComponent };